<h3>
  <span>
    {{ "title.AmtlicheBewertung" | translate }}
  </span>
</h3>

<div>
  <cap-beschreibung-table-wrapper [tableFullWidth]="tableFullWidth" class="my-1">
    <span class="cap-table-wrapper-title" style="font-weight: bold">
      {{ "Bewertung" | translate }}
    </span>
    <ng-container class="cap-table-wrapper-content">
      <cap-list-loader [hasRight]="hasRight" [listLoader]="listLoader" [showTotal]="false" [showZeilenSelect]="false">
        <div class="cap-list-loader-content">
          <table class="cap-table-detail">
            <tbody>
              <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
            </tbody>
          </table>
        </div>
      </cap-list-loader>
      <ng-template #tableRows>
        @for (bewertung of listLoader?.items; track bewertung) {
          <tr>
            <td>
              <cap-kompakt-amtliche-bewertung [amtlicheBewertung]="bewertung" [capHistinfo]="bewertung.histInfo">
              </cap-kompakt-amtliche-bewertung>
              <cap-kompakt-timepoint [item]="bewertung.histInfo?.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
            </td>
          </tr>
        }
      </ng-template>
    </ng-container>
  </cap-beschreibung-table-wrapper>
</div>
